import {createContext, use} from 'react'

export interface ThemeContextValue {
	primaryColor: string
	setPrimaryColor: (hex: string) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme() {
	const context = use(ThemeContext)
	if (!context) {
		throw new Error('useTheme must be used within a ThemeProvider')
	}
	return context
}
